import "./Expertise.module.css";
import NavegacionPrincipal from "@/reusable_sections/Header";
import DasParkett from "./sections/DasParkett";
import MeetTheTeam from "./sections/MeetTheTeam";
import TheEcoShineProcess from "./sections/TheEcoShineProcess";
import FairPlayMechanics from "./sections/FairPlayMechanics";
import Footer from "@/reusable_sections/Footer";
export default function ExpertisePage() {
  return <div>
      <NavegacionPrincipal />
      <DasParkett />
      <MeetTheTeam />
      <TheEcoShineProcess />
      <FairPlayMechanics />
      <Footer />
    </div>;
}